import { VettingApi } from "@/api/vetting";
import { ApproveUserRequest } from "@/api/vetting/types/approve-user.types";
import { useUIStore } from "@/stores";
import { QueryKey, ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useApproveUser = () => {
  const notify = useNotify();
  const queryClient = useQueryClient();
  const { closeModal } = useUIStore();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: ApproveUserRequest) => VettingApi.approveUser(body),
    onError: (error) => {
      closeModal();
      notify(error, { type: "error" });
    },
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.USER, userId],
      });
      queryClient.invalidateQueries({
        queryKey: [ResourceName.VETTING_USERS],
      });
      closeModal();
      notify("User is approved", { type: "success" });
    },
  });

  return {
    approveUser: mutate,
    isApproveUserLoading: isPending,
  };
};
